<template>
  <section>
    <form class="topup-form" @submit.prevent="submit">
      <div class="topup-form-frame">
        <h1 class="step-title" v-html="$t('component.autotopup.stage4.title')"></h1>
        <h2 class="dark-title" v-html="$t('component.autotopup.stage4.header')"></h2>

        <el-alert v-if="isRegulationsError"
                  type="error"
                  :closable="false"
                  :title="$t('component.autotopup.stage4.agreementErrorHeader')"
                  :description="$t('component.autotopup.stage4.agreementErrorMessage')"
                  show-icon>
        </el-alert>

        <section class="payment-methods">
          <div class="payment-method card" tabindex="0"
               :class="{active: isPaymentMethodCard}"
               @click="setPaymentMethod(PAYMENT_METHOD_TYPE.creditCard, $event)"
               @keydown.space.prevent="setPaymentMethod(PAYMENT_METHOD_TYPE.creditCard, $event)"
               @keydown.enter.prevent="setPaymentMethod(PAYMENT_METHOD_TYPE.creditCard, $event)">
            <span>{{ $t('component.autotopup.stage4.paymentMethodCard') }}</span>
            <span class="img"></span>
          </div>
          <div class="payment-method blik" tabindex="0"
               :class="{active: isPaymentMethodBlik}"
               @click="setPaymentMethod(PAYMENT_METHOD_TYPE.blikRecurring, $event)"
               @keydown.space.prevent="setPaymentMethod(PAYMENT_METHOD_TYPE.blikRecurring, $event)"
               @keydown.enter.prevent="setPaymentMethod(PAYMENT_METHOD_TYPE.blikRecurring, $event)">
            <span>{{ $t('component.autotopup.stage4.paymentMethodBlik') }}</span>
            <span class="img"></span>
          </div>
<!--              <div class="payment-method card">-->
<!--                <input type="radio"-->
<!--                       name="topupType"-->
<!--                       id="topupTypePeriod"-->
<!--                       :class="{active: isPaymentMethodCard}"-->
<!--                       v-model="form.condition"-->
<!--                       :value="topupConditions.period"/>-->
<!--                <label for="topupTypePeriod">-->
<!--                  {{ $t('component.autotopup.stage1.periodLabel') }}-->
<!--                </label>-->
<!--              </div>-->
<!--              <div class="payment-method blik">-->
<!--                <input type="radio"-->
<!--                       name="topupType"-->
<!--                       id="topupTypeDay"-->
<!--                       :class="{active: isPaymentMethodBlik}"-->
<!--                       v-model="form.condition"-->
<!--                       :value="topupConditions.day"/>-->
<!--                <label for="topupTypeDay">-->
<!--                  {{ $t('component.autotopup.stage1.dayLabel') }}-->
<!--                </label>-->
<!--              </div>-->
        </section>

        <div class="topup-summary-frames">
          <p v-html="$t('component.autotopup.stage4.summaryHeader')"></p>
          <div>
            <div class="topup-summary-frame">
              <h3 class="topup-summary-frame-title">{{ $t('component.autotopup.stage4.topupInfoLabel') }}</h3>
              <div>
                <span>{{ $t('component.autotopup.stage4.topupInfoType1Label') }}</span>
                <p>{{ $t('component.autotopup.stage4.topupInfoType1Text') }}</p>
              </div>
              <div>
                <span>{{ $t('component.autotopup.stage4.topupInfoType2Label') }}</span>
                <p>{{ $t('component.autotopup.stage4.topupInfoType2Text') }}</p>
              </div>
              <div>
                <span>{{ $t('component.autotopup.stage4.topupInfoAmountLabel') }}</span>
                <p>{{ autotopup.amount | pln }} zł</p>
              </div>
              <div v-if="isConditionDaySet">
                <span>{{ $t('component.autotopup.stage4.topupInfoDayLabel') }}</span>
                <p>{{ autotopup.day }}</p>
              </div>
              <div v-if="isConditionPeriodSet">
                <span>{{ $t('component.autotopup.stage4.topupInfoPeriodLabel') }}</span>
                <p>{{ $t('component.autotopup.stage4.topupInfoPeriodText', {day: autotopup.day}) }}</p>
              </div>
              <div v-if="isConditionPeriodSet">
                <span>{{ $t('component.autotopup.stage4.topupInfoNextDateLabel') }}</span>
                <p>{{ autotopup.nextTopupDate }}</p>
              </div>
            </div>

            <div class="topup-summary-frame">
              <h3 class="topup-summary-frame-title">{{ $t('component.autotopup.stage4.topupContactLabel') }}</h3>
              <div>
                <span>{{ $t('component.autotopup.stage4.topupContactPhoneLabel') }}</span>
                <p>{{ autotopup.contact.msisdn | phone }}</p>
              </div>
              <div>
                <span>{{ $t('component.autotopup.stage4.topupContactNameLabel') }}</span>
                <p>{{ autotopup.contact.description }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="topup-agreements">
          <div class="with-checkbox">
            <input type="checkbox" id="agreement" v-model="form.agreement" autocomplete="off" />
            <label class="check-label" for="agreement">
              <span class="check-label-box"></span>
              <span class="check-label-text" v-html="$t('component.autotopup.stage4.agreementText', {regulationUrl: getRegulationUrl()})"></span>
            </label>
          </div>
          <div class="with-checkbox">
            <input type="checkbox" id="payment" v-model="form.payment" autocomplete="off" />
            <label class="check-label" for="payment">
              <span class="check-label-box"></span>
              <span class="check-label-text" v-html="$t('component.autotopup.stage4.paymentText')"></span>
            </label>
          </div>
          <div class="with-checkbox" v-if="isPaymentMethodCard">
            <input type="checkbox" id="terms" v-model="form.terms" autocomplete="off" />
            <label class="check-label" for="terms">
              <span class="check-label-box"></span>
              <span class="check-label-text" v-html="$t('component.autotopup.stage4.termsText', {regulationUrl: getRegulationUrl()})"></span>
            </label>
          </div>
          <p><span class="red">*</span>&nbsp;<span v-html="$t('component.autotopup.stage4.required')"></span></p>
        </div>
      </div>
      <div class="topup-form-buttons">
        <button id="go-back-step-4"
                type="button"
                @click="goBack"
                :title="$t('component.autotopup.stage4.a11y.toPreviousStepButton')">
          ‹ {{ $t('component.autotopup.stage4.buttonBack') }}
        </button>
        <button id="submit-step-4"
                :disabled="!isFormValid() || isLoading"
                type="submit"
                :title="$t('component.autotopup.stage4.a11y.submitButton')">
          {{ $t('component.autotopup.stage4.buttonNext') }} ›
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import Stage4Mixin from '@/common/mixins/Topup/Auto/Stage4.mixin'

export default {
  name: 'TopupAutoStage4',
  mixins: [Stage4Mixin]
}
</script>

<style src="../../../assets/scss/topup-form.scss" lang="scss"></style>
<style lang="scss">
@import '../../../assets/scss/variables';
@mixin focus-visible-style {
  border-radius: 2px;
  outline: solid 2px #0067df;
  outline-offset: 2px;
}

.payment-methods {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: $res-s) {
    flex-direction: row;
    gap: 30px;
  }

  .payment-method {
    border: 1px solid #c4c4c4;
    cursor: pointer;
    padding: 15px 10px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media (min-width: $res-m) {
      width: unset;
      padding: 20px 10px;
      min-width: 210px;
      gap: 15px;
    }

    &:focus-visible {
      @include focus-visible-style;
    }

    .img {
      display: block;
      min-height: 50px;
      width: 100%;
    }

    &.card {
      .img {
        width: 90%;
        background: url("../../../assets/images/mc.png") no-repeat center center;
        background-size: auto;

        @media (min-width: $res-s) {
          background-size: contain;
        }
      }
    }

    &.blik {
      .img {
        background: url("../../../assets/images/blik.png") no-repeat center center;
        background-size: contain;
      }
    }

    &.active {
      border: 2px solid #2cb43a;
    }
  }
}
</style>
